<section>
  <mat-card class="home-list">
    <mat-card-header>
      <mat-card-title class="pl-5"
        >Gestión de usuarios<button
          mat-icon-button
          class="float-right mr-5"
          data-toggle="collapse"
          data-target="#collapseSearch"
          aria-expanded="false"
          aria-controls="collapseSearch"
        >
          Añadir<mat-icon>add_circle</mat-icon>
        </button></mat-card-title
      >
    </mat-card-header>

    <!------------- Add USers ------------------>
    <mat-divider></mat-divider>
    <div class="collapse" id="collapseSearch">
      <div [formGroup]="addForm" style="padding: 16px">
        <div class="row">
          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Password</label>
            <input type="text" class="form-control" formControlName="pass" />
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12">
            <label class="form-label">Rol</label>
            <select
              class="custom-select form-control"
              formControlName="rol"
              (change)="setRol()"
            >
              <option value="">---------</option>
              <option value="GRUPO">Gerencia</option>
              <option value="ADMIN">Administrador</option>
              <option value="VENTAS">Ventas</option>
              <option value="CONSULTA">Consulta</option>
            </select>
          </div>

          <div
            class="col-lg-2 col-md-6 col-sm-12"
            *ngIf="rol === 'ADMIN' || rol === 'VENTAS' || rol === 'CONSULTA'"
          >
            <label class="form-label">Colaborador</label>
            <select
              class="custom-select form-control"
              formControlName="colaborador"
            >
              <option>------------</option>
              <option
                *ngFor="let colaborador of colaboradores"
                [value]="colaborador"
              >
                {{ colaborador }}
              </option>
            </select>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-12" *ngIf="rol === 'GRUPO'">
            <label class="form-label">Grupo</label>
            <select class="custom-select form-control" formControlName="grupo">
              <option value="">------------</option>
              <option *ngFor="let grupo of grupos" [value]="grupo">
                {{ grupo }}
              </option>
            </select>
          </div>

          <div class="col-lg-2 botones">
            <label class="form-label"></label>
            <button
              mat-button
              class="aceptar form-control"
              [disabled]="!addForm.valid"
              (click)="addUser()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>

    <mat-card-content>
      <div class="row">
        <div class="col-2">
          <mat-form-field class="mt-2">
            <mat-label>Busqueda general</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input />
          </mat-form-field>
        </div>
        <div class="col-2">
          <mat-form-field class="mt-2">
            <mat-label>Histórico expedientes</mat-label>
            <mat-select
              [(ngModel)]="seleccionado"
              (selectionChange)="updateHistorico()"
            >
              <mat-option *ngFor="let rango of rangos" [value]="rango.id">
                {{ rango.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabla principal --------- -------------------------->
      <mat-table [dataSource]="dataSoruce" matSort>
        <!-- Colaborador -->
        <ng-container matColumnDef="colaborador">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Colaborador
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="colaborador">
            {{ element.colaborador }}
          </mat-cell>
        </ng-container>

        <!-- Email -->
        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Correo
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="email">
            {{ element.email }}
          </mat-cell>
        </ng-container>

        <!-- Rol -->
        <ng-container matColumnDef="rol">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Rol
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="rol">
            {{ element.rol }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            Acciones
          </mat-header-cell>
          <mat-cell *matCellDef="let element" data-label="F.recepcion">
            <!--<button mat-icon-button >
              <mat-icon>info</mat-icon>
            </button>-->
            <button
              mat-icon-button
              (click)="setPassword(element)"
              matTooltip="Restablecer contraseña"
            >
              <mat-icon>lock</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="setData(element)"
              matTooltip="Modificar datos"
              *ngIf="element.rol != 'ROLE_SUPERADMIN'"
            >
              <mat-icon>manage_accounts</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="deleteUser(element)"
              matTooltip="Borrar usuario"
              *ngIf="element.rol != 'ROLE_SUPERADMIN'"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns" class="fila"></mat-row>
      </mat-table>
      <mat-paginator
        #MatPaginator
        [pageSizeOptions]="[5, 10, 15, 25, 50, 100]"
        [pageSize]="10"
        showFirstLastButtons
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</section>

<ng-template #password class="text-center">
  <h2 mat-dialog-title class="text-center">Generar nueva contraseña</h2>
  <mat-dialog-content class="text-center">
    <div [formGroup]="passForm" style="padding: 16px">
      <div class="row">
        <div class="col-12">
          <label class="form-label">Nuevo password</label>
          <input type="text" class="form-control" formControlName="pass" />
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <button mat-button matDialogClose class="aceptar float-left">
          Cerrar
        </button>
        <button
          mat-button
          [mat-dialog-close]="true"
          class="aceptar"
          [disabled]="!passForm.valid"
        >
          Guardar
        </button>
      </div>
      <div class="col-1"></div>
    </div>
  </mat-dialog-actions>
</ng-template>

<ng-template #data class="text-center">
  <h2 mat-dialog-title class="text-center">Modificar datos</h2>
  <mat-dialog-content class="text-center">
    <div [formGroup]="dataForm" style="padding: 16px">
      <div class="row">
        <div class="col-12">
          <label class="form-label">Correo</label>
          <input type="text" class="form-control" formControlName="email" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label">Rol</label>
          <select class="custom-select form-control" formControlName="rol">
            <option value="ADMIN">Administrador</option>
            <option value="VENTAS">Ventas</option>
            <option value="CONSULTA">Consulta</option>
          </select>
          <label *ngIf="this.colaborador.rol === 'GRUPO'"
            >*No es posible cambiar rol si el usuario tiene asigando el rol
            Gerencia</label
          >
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <button mat-button matDialogClose class="aceptar float-left">
          Cerrar
        </button>
        <button
          mat-button
          [mat-dialog-close]="true"
          class="aceptar"
          [disabled]="!dataForm.valid"
        >
          Guardar
        </button>
      </div>
      <div class="col-1"></div>
    </div>
  </mat-dialog-actions>
</ng-template>

<ng-template #delete class="text-center">
  <h2 mat-dialog-title class="text-center">Modificar datos</h2>
  <mat-dialog-content class="text-center">
    <h6>¿Desea borrar el usuario seleccionado?</h6>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-10">
        <button mat-button matDialogClose class="aceptar float-left">
          Cancelar
        </button>
        <button mat-button [mat-dialog-close]="true" class="aceptar">
          Borrar
        </button>
      </div>
      <div class="col-1"></div>
    </div>
  </mat-dialog-actions>
</ng-template>
<!--

<div *ngIf="spinner" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
</div>
-->
